import { Branch } from '@/constants';

export const getDegreeOptionsFrom = (
  data: Branch[],
  selectedBranch: string | undefined,
  otherDegreeLabel: string
) => {
  if (!selectedBranch) return [];

  const selectedBranchData = data.find((branch: Branch) => branch.branch === selectedBranch);
  if (!selectedBranchData) return [];

  const baseOptions = selectedBranchData.degrees.map(degree => ({
    label: degree.degree_name,
    value: degree.degree_name
  }));

  return [
    ...baseOptions,
    {
      label: otherDegreeLabel,
      value: 'other'
    }
  ];
};
